import React, { useState } from 'react';
import Input from 'components/ui/Input';
import Select from 'components/ui/Select';
import { Checkbox } from 'components/ui/Checkbox';
import Icon from 'components/AppIcon';

const TimingSection = ({ urgency, preferredDate, preferredTimeSlot, onChange, errors }) => {
  const [showTimingInputs, setShowTimingInputs] = useState(false);
  
  const urgencyOptions = [
    { value: 'low', label: 'Bassa - Entro 2-4 settimane' },
    { value: 'medium', label: 'Media - Entro 1-2 settimane' },
    { value: 'high', label: 'Alta - Entro pochi giorni' },
    { value: 'urgent', label: 'Urgente - Il prima possibile' }
  ];

  const timeSlotOptions = [
    { value: 'morning', label: 'Mattina (8:00 - 12:00)' },
    { value: 'afternoon', label: 'Pomeriggio (12:00 - 18:00)' },
    { value: 'evening', label: 'Sera (18:00 - 20:00)' },
    { value: 'flexible', label: 'Flessibile' }
  ];

  const handleCheckboxChange = (checked) => {
    setShowTimingInputs(checked);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
          <Icon name="Clock" size={20} color="#f97316" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-foreground">Tempistiche</h2>
          <p className="text-sm text-muted-foreground">Quando ti serve il servizio?</p>
        </div>
      </div>

      <div className="space-y-4">
        {/* Checkbox to show timing inputs */}
        <div className="flex items-start gap-3">
          <Checkbox
            id="showTiming"
            checked={showTimingInputs}
            onCheckedChange={handleCheckboxChange}
          />
          <label
            htmlFor="showTiming"
            className="text-sm font-medium text-foreground cursor-pointer select-none"
          >
            Voglio indicare una tempistica preferita
          </label>
        </div>

        {/* Timing inputs - shown only when checkbox is checked */}
        {showTimingInputs && (
          <div className="space-y-4 animate-in fade-in slide-in-from-top-2 duration-300">
            <Select
              label="Livello di Urgenza"
              options={urgencyOptions}
              value={urgency}
              onChange={(value) => onChange('urgency', value)}
              error={errors?.urgency}
              required
            />

            <Input
              type="date"
              label="Data Preferita (Opzionale)"
              value={preferredDate}
              onChange={(e) => onChange('preferredDate', e?.target?.value)}
              error={errors?.preferredDate}
              description="Indica una data preferita per l'intervento"
              min={new Date()?.toISOString()?.split('T')?.[0]}
            />

            <Select
              label="Fascia Oraria Preferita (Opzionale)"
              options={timeSlotOptions}
              value={preferredTimeSlot}
              onChange={(value) => onChange('preferredTimeSlot', value)}
              error={errors?.preferredTimeSlot}
              placeholder="Seleziona una fascia oraria"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TimingSection;